import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { useCallback, useEffect, useState } from 'react';
import useViewAccrual from 'src/hooks/useViewAccrual';
const GLCodeDropdownList = () => {
  const { glCodeList, selectedGlcode, setSelectedGlcode } = useViewAccrual();
  const [data, setData] = useState(glCodeList);

  const handleGlcodeChange = useCallback(
    (e: DropDownListChangeEvent) => {
      const { value } = e.target;
      setSelectedGlcode(value);
    },
    [setSelectedGlcode]
  );

  useEffect(() => {
    if (glCodeList.length > 1) {
      setData(glCodeList);
    }
  }, [glCodeList]);

  return (
    <div className="flex items-center gap-2 px-2">
      <div>GL Code: </div>
      <DropDownList
        id="view-drop-down-list"
        style={{ width: 200 }}
        data={data}
        textField="glCd"
        dataItemKey="glCdId"
        value={selectedGlcode}
        onChange={handleGlcodeChange}
      />
    </div>
  );
};

export default GLCodeDropdownList;
